import { CSSObject, Theme } from '@mui/material'

import { INPUT_WIDER_WIDTH } from 'providers/material-ui/theme/constants'

export const styles = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.white.main,
  width: INPUT_WIDER_WIDTH,
  zIndex: theme.zIndex.tableFilter,
})
